import React, { useEffect, useState } from "react";
import { FileText, DownloadSimple, CheckCircle, XCircle, MagnifyingGlass } from "@phosphor-icons/react";
import { useAuth } from "../../context/AuthContext";
import api, { API } from "../../lib/api";
import { toast } from "sonner";

const STATUS = [
  { key: "in_review", label: "Mettre en étude", icon: MagnifyingGlass, color: "text-gold" },
  { key: "approved", label: "Accepter", icon: CheckCircle, color: "text-green-600" },
  { key: "rejected", label: "Refuser", icon: XCircle, color: "text-red-600" },
];
const STATUS_LABEL = { submitted: "Déposé", in_review: "En étude", approved: "Accepté", rejected: "Refusé" };

const BankDashboard = () => {
  const { user } = useAuth();
  const [dossiers, setDossiers] = useState([]);
  const token = localStorage.getItem("yad_token");

  const load = () => api.get("/bank/dossiers").then(({ data }) => setDossiers(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    const note = status === "rejected" || status === "approved" ? window.prompt("Note à destination de l'investisseur (optionnel) :") || "" : "";
    await api.put(`/bank/dossiers/${id}/status`, { status, note });
    toast.success("Statut mis à jour");
    load();
  };

  const fileUrl = (fid) => `${API}/files/${fid}?auth=${token}`;

  return (
    <div className="relative z-10 pt-[72px] min-h-screen bg-background">
      <div className="bg-navy text-white py-14">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 flex items-center gap-4">
          <img src="/cam-logo.jpg" alt="CAM" className="h-10 bg-white rounded px-2 py-1" />
          <div>
            <span className="overline text-gold">Espace bancaire</span>
            <h1 className="font-display text-3xl sm:text-4xl font-light tracking-tight">Dossiers de financement</h1>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-10 space-y-5">
        {dossiers.length === 0 && <div className="bg-white border border-dashed border-navy/20 rounded-2xl p-10 text-center text-muted-foreground">Aucun dossier déposé pour l'instant.</div>}
        {dossiers.map((d) => (
          <div key={d.id} data-testid={`bank-dossier-${d.id}`} className="bg-white border border-navy/10 rounded-2xl p-6">
            <div className="flex justify-between items-start flex-wrap gap-3 mb-4">
              <div>
                <div className="font-display text-xl text-navy">{d.user_name}</div>
                <div className="text-xs text-muted-foreground">{d.user_email}</div>
              </div>
              <span className={`text-xs font-semibold uppercase tracking-wider px-3 py-1.5 rounded-full ${d.status === "approved" ? "bg-green-100 text-green-700" : d.status === "rejected" ? "bg-red-100 text-red-700" : "bg-gold/15 text-gold"}`}>{STATUS_LABEL[d.status] || d.status}</span>
            </div>

            <div className="grid sm:grid-cols-2 gap-2 mb-5">
              {(d.documents || []).map((doc) => (
                <div key={doc.key} className="flex items-center gap-2 text-sm border border-navy/10 rounded-lg px-3 py-2">
                  <FileText size={18} weight="light" className="text-navy shrink-0" />
                  <span className="flex-1 truncate text-navy">{doc.label?.fr || doc.label}</span>
                  {doc.file_id ? (
                    <a href={fileUrl(doc.file_id)} target="_blank" rel="noopener noreferrer" data-testid={`download-${doc.key}`} className="text-gold hover:text-[#C8924A] inline-flex items-center gap-1 text-xs font-medium">
                      <DownloadSimple size={16} /> Voir
                    </a>
                  ) : <span className="text-xs text-muted-foreground">manquant</span>}
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-2">
              {STATUS.map((s) => (
                <button key={s.key} data-testid={`status-${s.key}-${d.id}`} onClick={() => setStatus(d.id, s.key)} className={`inline-flex items-center gap-2 text-sm border border-navy/15 rounded-full px-4 py-2 hover:border-gold transition-colors ${s.color}`}>
                  <s.icon size={16} weight="light" /> {s.label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BankDashboard;
